import axiosInstance from '../api';

export interface NewClientPause {
  active: boolean;
  pauseStart: string | null;
}

interface HealthResponse {
  status: string;
  database: string;
  timestamp: string;
  newClientPause?: NewClientPause;
}

const healthService = {
  find: async (): Promise<HealthResponse> => {
    const response = await axiosInstance.get('/health');
    return response.data;
  },
};

export default healthService;
